'use es6';

import { userPortal as userPortalLocalStorage, tryConvertLegacyStorage } from 'DesignData/lib/localStorage';
import { FINDER_OPTIONS } from 'DesignData/enums/attributes/UserPortal';
const legacyKeySuffix = 'finder:options';
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @returns {Promise}
 */

export function fetch(userId, portalId) {
  const storageClient = userPortalLocalStorage(userId, portalId, FINDER_OPTIONS);
  return tryConvertLegacyStorage(storageClient, legacyKeySuffix) || storageClient.fetchAsync();
}
/**
 * @param {Number} userId
 * @param {Number} portalId
 * @param {Object} data
 * @returns {Promise}
 */

export function save(userId, portalId, data) {
  const storageClient = userPortalLocalStorage(userId, portalId, FINDER_OPTIONS);
  return storageClient.saveAsync(data);
}